$(function() {
    $(".urban-homes-offscreen-open").click(function () {
        $("#urban-homes-offscreen").addClass("open");
    })
    $("#urban-homes-offscreen-close").click(function() {
        $("#urban-homes-offscreen").removeClass("open");
    })
});
